module.exports = __webpack_public_path__ + "static/media/比赛4.bba3c2fd.jpg";